import { Box } from '@material-ui/core';
import generateSafeHtmlTags from '../../utils/generateSafeHtmlTags';

const SafeHTML = ({ text }) => {
    return (
     <Box component='div' dangerouslySetInnerHTML={ generateSafeHtmlTags(text) } />
    );
}
export default SafeHTML;